import { render, staticRenderFns } from "./PoisForm.vue?vue&type=template&id=ef6139f0&scoped=true&"
import script from "./PoisForm.vue?vue&type=script&lang=js&"
export * from "./PoisForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6139f0",
  null
  
)

export default component.exports